<div class="filter-row">
  <div class="filter-left">
    <search-type typ="de" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>
    <search-type typ="cn" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>

    <button class="btn btn-info btn-sm" type="button" (click)="badge('0')" [ngClass]="{active: q('0')}">
      Beauftragt <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-primary btn-sm" type="button" (click)="badge('1')" [ngClass]="{active: q('1')}">
      Bestätigt <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-primary btn-sm" type="button" (click)="badge('200')" [ngClass]="{active: q('200')}">
      DE Bestätigt ohne BA <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-purple btn-sm" type="button" (click)="badge('2')" [ngClass]="{active: q('2')}">
      In Produktion <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-rose btn-sm" type="button" (click)="badge('3')" [ngClass]="{active: q('3')}">
      Produziert <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="badge('4')" [ngClass]="{active: q('4')}">
      Geliefert <span class="badge ng-binding"></span>
    </button>
    <button class="btn btn-success btn-sm" type="button" (click)="badge('5')" [ngClass]="{active: q('5')}">
      Abgerechnet <span class="badge ng-binding"></span>
    </button>
    @if (('fetch.change.status.concluded_not_billed'|HasPerm)) {
      <button class="btn btn-default btn-sm"
        type="button"
        [ngClass]="{active: q('102')}"
        (click)="badge('102')"
        >
        Abgeschlossen / nicht Abgerechnet<span class="badge ng-binding"></span>
      </button>
    }

    <button class="btn btn-default btn-sm active" type="button" (click)="badge('all')"
      [ngClass]="{active: q('all') === true}">
      Alle <span class="badge ng-binding"></span>
    </button>

    &nbsp;

    <button class="btn btn-danger btn-sm" type="button" (click)="badge('kanban')" [ngClass]="{active: q('kanban')}">
      Kanban <span class="badge"></span>
    </button>

    <button type="button"
            class="btn btn-danger btn-sm"
            [ngClass]="{active: q('true', 'price_not_confirmed')}"
            (click)="badge('true', 'price_not_confirmed', true)">
      Preis nicht Bestätigt <span class="badge"></span>
    </button>

    <button class="btn btn-default btn-sm" type="button" (click)="badge('false', 'has_delivery_date', true)"
      [ngClass]="{active: q('false', 'has_delivery_date')}">
      Ohne Liefertermin <span class="badge"></span>
    </button>

    &nbsp;

    @if (('fetch.export'|HasPerm)) {
      <ev-file-button title="Excel Liste herunterladen" [url]="excelUri" [link]="false">
        <i class="fa fa-download"></i>
      </ev-file-button>
    }

    @if (('fetch.export'|HasPerm)) {
      <ev-file-button [url]="downloadUrl('/workflow/v1/fetch/export/?short=true', true)" [link]="false">
        <i class="fa fa-download"></i> Kurz
      </ev-file-button>
    }
  </div>
  <div class="filter-right">

    <date-range [start]="null" [end]="null" (update)="updateCreatedDateRange($event)" class="float-right"></date-range>

    <h3 class="align-special float-right">
      Erstelldatum:
    </h3>

    <div class="clear-both">&nbsp;</div>

    <date-range [start]="null" [end]="null" (update)="updateDateRange($event)" class="float-right"></date-range>

    <h3 class="align-special float-right">
      Lieferdatum:
    </h3>

    <div class="clear-both">&nbsp;</div>
  </div>
</div>

<form #changeForm="ngForm" name="form">
  <table class="table whitetable">
    <thead>
      <tr>
        <th>
          <a (click)="sort($event, 'task_list_id', 'ASC')" [href]="sortUrl('task_list_id', 'ASC')">
            Vorgang
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_status', 'ASC')"
            [href]="sortUrl('task_workflow_fetch_status', 'ASC')">
            Status
          </a>
        </th>
        <th>
          Abruf
        </th>
        <th class="w-48 align-right">
          <a (click)="sort($event, 'task_workflow_fetch_position_quanity', 'DESC')"
            [href]="sortUrl('task_workflow_fetch_position_quanity', 'DESC')">
            Stückzahl
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_date_created', 'ASC')"
            [href]="sortUrl('task_workflow_fetch_date_created', 'ASC')">
            Erstelldatum
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_delivery', 'ASC')"
            [href]="sortUrl('task_workflow_fetch_delivery', 'ASC')">
            Lieferdatum
          </a>
        </th>
        <th colspan="2">
          Artikelstatus
        </th>
        <th>
          <a (click)="sort($event, 'task_list_sds_nr', 'ASC')" [href]="sortUrl('task_list_sds_nr', 'ASC')">
            SDS-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_oa_nr', 'ASC')" [href]="sortUrl('task_list_oa_nr', 'ASC')">
            0A-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_kd_art_nr', 'ASC')" [href]="sortUrl('task_list_kd_art_nr', 'ASC')">
            Kd-Art-Nr.
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_customer_name', 'ASC')"
            [href]="sortUrl('task_list_customer_name', 'ASC')">
            Kunde
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_customer_city', 'ASC')"
            [href]="sortUrl('task_list_customer_city', 'ASC')">
            Lieferadresse Stadt
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_customer_field_service', 'ASC')"
            [href]="sortUrl('task_list_customer_field_service', 'ASC')">
            Vertriebsgebiet
          </a>
        </th>
        <th>
          Lagerbestand
        </th>
      </tr>
      <tr class="filterrow">
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sid" name="sid" [autofocus] autocomplete="off search-fetch-id">
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <input type="text" class="form-control input-sm text-right" [(ngModel)]="data.quantity" name="quantity">
        </th>
        <th class="w-32"></th>
        <th class="w-32">
          <ev-datepicker [(ngModel)]="data.delivery_date" name="delivery_date" class="form-control input-sm"
            [allDates]="true">
          </ev-datepicker>
        </th>
        <th></th>
        <th>
          <fetch-article-usage-state-dropdown name="article_usage_state" [(ngModel)]="data.article_usage_state">
          </fetch-article-usage-state-dropdown>
        </th>
        <th class="w-32">
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sds_nr" name="sds_nr">
        </th>
        <th class="w-32">
          <input type="text" class="form-control input-sm" [(ngModel)]="data.oa_nr" name="sds_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.kd_art_nr" name="kd_art_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.customer_name" name="customer_name">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.customer_city" name="customer_city">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.customer_field_service"
            name="customer_field_service">
        </th>
        <th>
          &nbsp;
        </th>
      </tr>
    </thead>
    <tbody>
      @for (object of list.objects; track object; let index = $index) {
        <tr [ngClass]="object.css">
          <td>
            <a uiSref="a.workflow.detail" [uiParams]="{id: object.task.id}">
              @if (object.task.typ === 'cn') {
                <img src="/ui/assets/images/flags/cn.png">
              }
              @if (object.task.typ === 'de') {
                <img src="/ui/assets/images/flags/de.png">
              }
              {{ object.task.id }}
              @if (object.task.comments > 0) {
                <span class="td-comments" title="Kommentar(e) vorhanden">
                  <i class="fa fa-comments"></i>
                </span>
              }
              @if (object.task.kanban) {
                <span class="label label-danger">Kanban</span>
              }
            </a>
          </td>
          <td>
            <ev-status-label type="fetch_status" [state]="object.fetch.status"></ev-status-label>
            @if (object.task.express_service) {
              <i class="fa fa-exclamation-triangle"></i> EIL
            }
            @if (object.fix_date) {
              <i class="fa fa-exclamation-triangle"></i> FIX
            }
          </td>
          <td>{{ object.fetch.ordering }} von {{ object.task.fetches }}</td>
          <td class="text-right">{{ object.position.quanity|money }}</td>
          <td>
            {{ object.fetch.date_created }}
            @if (object.call_for_action_price) {
              <span class="fa fa-stack subscript right h-lh! leading-[inherit]! align-top!"
                    title="Preis nicht Bestätigt">
                <i class="fa fa-euro fa-stack-1x text-black"></i>
                <i class="fa fa-times fa-stack-2x text-storz-red text-px-12!"></i>
              </span>
            }
          </td>
          <td>{{ object.fetch.delivery }}</td>
          <td>
            <workflow-article-state [articleState]="object.task.article_state_change"></workflow-article-state>
          </td>
          <td>
            <fetch-article-usage-state-label [fetchState]="object.fetch.status"
              [articleUsageState]="object.fetch.article_usage_state">
            </fetch-article-usage-state-label>
          </td>
          <td>
            <strong>{{ object.task.sds_nr }}</strong>
          </td>
          <td>{{ object.task.oa_nr }}</td>
          <td>
            {{ object.task.kd_art_nr }}
            @if (object.task.kd_art_index) {
              <span class="label label-default">
                {{ object.task.kd_art_index }}
              </span>
            }
          </td>
          <td>
            <a uiSref="a.crm.customer.detail" [uiParams]="{id:object.task.customer_id}" target="_blank">
              {{ object.task.customer_name }}
            </a>
          </td>
          <td>
            {{ object.task.customer_city }}
          </td>
          <td>
            {{ object.task.customer_field_service }}
          </td>
          <td>
            {{ object.inventory }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</form>

<ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
